import { isBool } from "_helpers";

import dayjs from 'dayjs';

const dateRender = (date) => {
    if( !date || date === '0000-00-00' ) return '';
    const d = dayjs(date);
    return d.isValid() ? d.format('DD/MM/YYYY') : '';
};

const boolList = [
    { value: "_empty", label: "Sélection", disabled: true },
    { value: "1", label: "Oui" },
    { value: "0", label: "Non" }
]

const activityList = [
    { value: "_empty", label: "Sélection", disabled: true },
    { value: "low", label: "Basse" },
    { value: "medium", label: "Moyenne" },
    { value: "high", label: "Haute" }
]

const roleList = [
    { value: "_empty", label: "Sélection", disabled: true },
    { value: "user", label: "Utilisateur" }
]

const boolRender = ( val ) => {
    const find = boolList.find(el => el.value === val);
    return find?.['label'] ?? val; 
} 

const activityRender = ( val ) => {
    const find = activityList.find(el => el.value === val);
    return find?.['label'] ?? val;
}

const roleRender = ( val ) => {
    const find = roleList.find(el => el.value === val);
    return find?.['label'] ?? val;
}

export const apiColumns = [
    {
        title: "Domaine",
        dataIndex: "domain",
        width: "10%",
        inputType: "text",
        editable: true
    },{
        title: "Clé api",
        dataIndex: "apikey",
        width: "25%",
        inputType: "text",
        editable: true
    },{
        title: "Dans le reporting ?",
        dataIndex: "in_reporting",
        width: "10%",
        inputType: "select",
        inputValues: boolList,
        editable: true,
        required: false,
        render: boolRender
    },{
        title: "Dans l'état des dossiers ?",
        dataIndex: "in_filestatus",
        width: "10%",
        inputType: "select",
        inputValues: boolList,
        editable: true,
        required: false,
        render: boolRender
    },{
        title: "Dans le suivi des dossiers ?",
        dataIndex: "in_filetracking",
        width: "10%",
        inputType: "select",
        inputValues: boolList,
        editable: true,
        required: false,
        render: boolRender
    },{
        title: "Dans la liste des licences ?",
        dataIndex: "in_dashboard_licenses",
        width: "10%",
        inputType: "select",
        inputValues: boolList,
        editable: true,
        required: false,
        render: boolRender
    },{
        title: "Activité",
        dataIndex: "activity",
        width: "10%",
        inputType: "select",
        inputValues: activityList,
        editable: true,
        required: false,
        render: activityRender
    }
];

export const remoteLicensesColumns = [
    {
        title: "Base",
        dataIndex: "base",
        width: "10%",
        inputType: "text",
        editable: true,
        render: (_,{ key, parent }) => parent === 'root' ? key.toUpperCase() : null
    },{
        title: "Nom",
        dataIndex: "name",
        width: "15%",
        inputType: "text",
        editable: true
    },{
        title: "Email",
        dataIndex: "email",
        width: "25%",
        inputType: "text",
        editable: true
    },{
        title: "Activée le",
        dataIndex: "date_activation",
        width: "15%",
        inputType: "date",
        editable: true,
        render: dateRender
    },{
        title: "Désactivée le",
        dataIndex: "date_deactivation",
        width: "15%",
        inputType: "date",
        editable: true,
        required: false,
        render: dateRender

    },{
        title: "Enfant de",
        dataIndex: "parent",
        width: "15%",
        inputType: "select",
        editable: true,
        required: false,
        render: (t) => {
            if( !t ||  t === 'root' ) return null ;
            return t.toUpperCase();
        }
    }
];

export const permissionsColumns = [
    {
        title: "Clé",
        dataIndex: "key",
        width: "20%",
        inputType: "text",
        align: "left",
        editable: true
    },{
        title: "Nom",
        dataIndex: "txt",
        width: "40%",
        inputType: "text",
        editable: true
    },{
        title: "Enfant de",
        dataIndex: "parent",
        width: "25%",
        inputType: "select",
        editable: true,
        required: false,
        render: (t) => {
            if( !t ||  t === 'root' ) return null ;
            return t;
        }
    }
];
   
export const usersColumns = [
    {
        title: "Nom d'utilisateur",
        dataIndex: "username",
        width: "20%",
        inputType: "text"
    },{
        title: "E-mail",
        dataIndex: "email",
        width: "30%",
        inputType: "text",
        editable: true
    },{
        title: "Rôle",
        dataIndex: "role",
        width: "10%",
        inputType: "select",
        inputValues: roleList,
        editable: true,
        render: roleRender
    },{
        title: "Permissions",
        dataIndex: "permissions",
        width: "25%",
        inputType: "select",
        mode: "multiple",
        maxTagCount: "responsive",
        editable: true,
        render: (t) => {
            if( !t ) return null ;
            return t.map(e => e.trim()).join(", ")
        }
    }
];